import { render, staticRenderFns } from "./label-badge.vue?vue&type=template&id=5d627ac1"
import script from "./label-badge.vue?vue&type=script&lang=js"
export * from "./label-badge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports